import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const pointsReminderEndpoint = {
    [pointsEndpointIds.POINTS_REMINDER]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
        // No difference between regular lambda,
        // but on the regular lambda we reached the max CloudFront description limit.
        isLowSpec: true,
    },
};
